import { CreateChatbot } from '../ui/create-chatbot';

export const ReservationAgreementCreateGather = () => {
  return <CreateChatbot />;
};
